module.exports = __webpack_public_path__ + "img/1697740098431.d2dd8c52.jpg";